import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RedirectionLoaderComponent} from "./components/redirection-loader/redirection-loader.component";
import {CoreRoute, CoreRouteParam} from "./constants/core-routes.enum";
import {AuthGuard} from "./guards/auth.guard";
import {AppComponent} from "./app.component";
import {RouteNotFoundGuard} from "./guards/route-not-found.guard";
import {PageNotFoundComponent} from "./components/page-not-found/page-not-found.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'not-found',
    pathMatch: 'full'
  },
  {
    path: ``,
    component: AppComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: `${CoreRoute.RedirectionLoader}/:${CoreRouteParam.AccessHash}`,
        component: RedirectionLoaderComponent
      }
    ]
  },
  {
    path: '**',
    canActivate: [RouteNotFoundGuard],
    component: PageNotFoundComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
